<template>
<div>
	<div>© {{new Date().getFullYear()}} by Seltec GmbH</div>
	<div>
		<a href="https://www.seltec.at/index.php/datenschutzrichtlinien.html" target="_blank">DSGVO</a> |
		<a href="https://www.seltec.at/index.php/agbs.html" target="_blank">AGB</a> |
		<a href="https://www.seltec.at/index.php/impressum.html" target="_blank">Impressum</a>
	</div>
</div>
</template>

<script>

export default {
	name: 'Footer',
};
</script>

<style lang="scss" scoped>
div {
	width:100%;
	text-align: center;
	color: #fff;
	font-size: 12px;
	a {
		color: #fff;
	}
}
</style>
